import * as React from 'react'

import { CustomTextInputProps, TextInput } from '@ally/forms'

export const validate = (value: string): string | void => {
  const errorMessage = 'Enter the last 4 digits of a valid tax ID.'

  if (!value) {
    return errorMessage
  }

  if (!/^[0-9]{4}$/.test(value)) {
    return errorMessage
  }

  return undefined
}

const LastFourTaxID: React.FC<CustomTextInputProps> = ({ name }) => {
  return (
    <TextInput
      labelContent="Last 4 digits of tax ID"
      inputType="text"
      isPrivate
      name={name}
      validate={validate}
      required
    />
  )
}

export default LastFourTaxID
